import React from "react";
import styles from "@styles/button.module.css";

interface CustomButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  // Add any additional custom props here
  customStyle?: string;
}

export const CustomButton: React.FC<CustomButtonProps> = ({
  customStyle,
  children,
  ...props
}) => {
  return (
    <button
      className={`${styles.button_styling} ${customStyle || ""}`}
      {...props}
    >
      {children}
    </button>
  );
};
